import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";

import axios from "axios";
import { Redirect } from "react-router-dom";

import { Button } from "components";

import SweetAlert from "react-bootstrap-sweetalert";

import nowLogo from "assets/img/nadu-logo-full.png";

import bgImage1 from "assets/img/minibg/bg1.jpg";
import bgImage2 from "assets/img/minibg/bg2.jpg";
import bgImage3 from "assets/img/minibg/bg3.jpg";
import bgImage4 from "assets/img/minibg/bg4.jpg";
import bgImage5 from "assets/img/minibg/bg5.jpg";
import bgImage6 from "assets/img/minibg/bg6.jpg";
import bgImage7 from "assets/img/minibg/bg7.jpg";
import bgImage8 from "assets/img/minibg/bg8.jpg";
import bgImage9 from "assets/img/minibg/bg9.jpg";
import bgImage10 from "assets/img/minibg/bg10.jpg";
import bgImage11 from "assets/img/minibg/bg11.jpg";
import bgImage12 from "assets/img/minibg/bg12.jpg";

const API = "https://oficina.nadunet.es/api/rest/";
const GET_USERNAME_URL = "nadulogin_resources/get_username.json";
const DO_LOGIN_URL = "user/login";
const GET_TOKEN_URL = "user/token";
const DO_LOGOUT_URL = "user/logout";
//replace :uid: with the User ID and :pass_reset_token: with the reset Token
const RESET_PASS_GET_TOKEN = "user/user_pass_reset";
//replace :uid: with the User ID and :pass_reset_token: with the reset Token
const RESET_PASS = "user/:uid:?pass-reset-token=:pass_reset_token:";
const REQUEST_PASS = "user/request_new_password";
const bgs = [
  bgImage1,
  bgImage2,
  bgImage3,
  bgImage4,
  bgImage5,
  bgImage6,
  bgImage7,
  bgImage8,
  bgImage9,
  bgImage10,
  bgImage11,
  bgImage12
];

class RequestPass extends React.Component {
  constructor(props) {
    super(props);
    //if (this.props.mainState.debug)
      //console.log("########## PROPS REQUEST PASS ###########");
    //if (this.props.mainState.debug) //console.log(props);
    let fields = {
      email: "emailField"
    };
    let randomBgNumber = this.randomIntFromInterval(0, 11);
    let randomBg = bgs[randomBgNumber];

    this.state = {
      fields: fields,
      [fields.email]: "",
      username: "",
      loginError: false,
      isLogging: false,
      randomBg: randomBg,
      showPassword: false,
      isDone: false,
      toLogin: false
    };

    this.startLogin = this.startLogin.bind(this);
    this.requestPassByEmail = this.requestPassByEmail.bind(this);
    this.getLoginButton = this.getRequestPassButton.bind(this);
    this.handleLoginError = this.handleLoginError.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
    this.miniLogout = this.miniLogout.bind(this);
    this.showLoginError = this.showLoginError.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  getRequestPassButton() {
    let loginButton = null;

    if (this.state.isLogging) {
      loginButton = (
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      );
    } else {
      loginButton = "Recuperar contraseña";
    }

    return loginButton;
  }
  startLogin() {
    alert(
      "Usuario: " +
        this.state.dniField +
        "\nContraseña: " +
        this.state.passField
    );
    this.getUsername();
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  requestPassByEmail(option) {
    if (this.state.isLogging && !option) return;
    /* //////console.log("################## GET USERNAME ################"); */

    this.setState({
      isLogging: true
    });

    let request = {
      name: this.state.emailField
    };
    /* //////console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + REQUEST_PASS, request, { withCredentials: false })
      .then(result => {
        this.setState({
          isLogging: false,
          isDone: true,
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-250px" }}
              title="¡Email enviado!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              En la bandeja de entrada de tu correo tendrás el enlace para restablecer tu contraseña
            </SweetAlert>
          )
        });
        ////console.log("################## RESPUESTA REQUEST ################");
        ////console.log(result);
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          /* //////console.log(error.request); */
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          /* //////console.log('Error', error.message); */
          this.setState({
            error,
            isLogging: false
          });
        }
        /* //////console.log(error.config); */
      });
  }
  resetPassword(pass_reset_token) {
    /* //////console.log("################## GET USERNAME ################"); */

    this.setState({
      isLogging: true
    });

    let request = {
      pass: this.state.passField
    };
    /* //////console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .put(
        API +
          RESET_PASS.replace(
            ":uid:",
            this.props.mainState.resetPass.uid
          ).replace(":pass_reset_token:", pass_reset_token),
        request,
        { withCredentials: false }
      )
      .then(result => {
        if (this.props.mainState.debug) //console.log("################## RESPUESTA RESET ################");
        if (this.props.mainState.debug) //console.log(result);
        if (result !== null && result.data != null && result.data.uid != null) {
          this.props.goToLogin();
        }
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          /* //////console.log(error.request); */
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          /* //////console.log('Error', error.message); */
          this.setState({
            error,
            isLogging: false
          });
        }
        /* //////console.log(error.config); */
      });
  }
  showLoginError() {
    var options = {
      place: "tr",
      message: "Credenciales incorrectas",
      type: "danger",
      icon: "now-ui-icons objects_key-25",
      autoDismiss: 3
    };
    this.props.showNotification(options);
  }
  goToLogin() {
    this.setState({
      toLogin: true
    });
  }
  handleLoginError(error) {
    //////console.log("#################### HANDLE ERROR ##################");
    //////console.log(error);
    switch (error) {
      case 406:
        this.setState({
          isLogging: false,
          alert: (
            <SweetAlert
              danger
              style={{ display: "block", marginTop: "-250px" }}
              title="No existe"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              El correo indicado no se corresponde con ninguna cuenta existente
            </SweetAlert>
          )
        });
        break;
      case 401:
        this.cleanSession();
        this.requestPassByEmail(error);
        break;
      case 500:
        this.requestPassByEmail(error);
        break;
      case 666:
        this.requestPassByEmail(error);
        break;
      default:
        this.setState({
          isLogging: false,
          alert: (
            <SweetAlert
              danger
              style={{ display: "block", marginTop: "-150px" }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              Se produjo un error, inténtalo de nuevo
            </SweetAlert>
          )
        });
        break;
    }
  }
  cleanSession() {
    let request = {};
    let newToken = "";

    //this.setState({ isLoading: true });
    axios
      .post(API + GET_TOKEN_URL, request, { withCredentials: true })
      .then(result => {
        //////console.log("################## RESPUESTA GET TOKEN ################");
        //////console.log(result);
        newToken = result.data.token;
        this.miniLogout(newToken);
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //////console.log(error.response.data);
          //////console.log(error.response.status);
          //////console.log(error.response.headers);

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          //////console.log(error.request);
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          //////console.log('Error', error.message);
          this.setState({
            error,
            isLogging: false
          });
        }
        //////console.log(error.config);
      });
  }
  miniLogout(newToken) {
    let request = {};
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + DO_LOGOUT_URL, request, {
        headers: queryHeaders.headers,
        withCredentials: true
      })
      .then(result => {
        //////console.log("################## RESPUESTA LOGOUT ################");
        //////console.log(result);

        if (result.data[0]) {
          this.getUsername();
        } else {
          this.cleanSession();
        }
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //////console.log(error.response.data);
          //////console.log(error.response.status);
          //////console.log(error.response.headers);

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          //////console.log(error.request);
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          //////console.log('Error', error.message);
          this.setState({
            error,
            isLogging: false
          });
        }
        //////console.log(error.config);
      });
  }
  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.toLogin === true) {
      this.redirectTo("/entrar");
      // return <Redirect to="/entrar" />;
    }
    //if (this.props.mainState.debug) //console.log("########## PROPS RESET PASS ###########");
    //if (this.props.mainState.debug) //console.log(this.props);
    let fields = this.state.fields;
    let loginErrorMessage = (
      <div className="pull-left link footer-link">
        <h6>Credenciales incorrectas</h6>
      </div>
    );
    return (
      <div>
        <div className="full-page-content">
          <div className="login-page">
          {this.state.alert}
            <Container>
              <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
                <Form>
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="now-logo" />
                      </div>
                    </CardHeader>
                    <CardBody>
                      {!this.state.isDone && <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.firstnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons ui-1_email-85" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Correo electrónico"
                          onFocus={e => this.setState({ firstnameFocus: true })}
                          onBlur={e => this.setState({ firstnameFocus: false })}
                          value={this.state[fields.email]}
                          onChange={e => this.handleChange(fields.email, e)}
                        />
                      </InputGroup>}
                    </CardBody>
                    <CardFooter>
                    {!this.state.isDone && <Button
                        block
                        round
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={this.requestPassByEmail}
                      >                     
                        {this.getRequestPassButton()}
                      </Button>}
                      {this.state.isDone && <Button
                        block
                        round
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={this.goToLogin}
                      >Volver al inicio de sesión</Button>}
                      {/* this.state.loginError && loginErrorMessage */}
                      {/* <div className="pull-right">
                        <h6>
                          <a href="#pablo" className="link footer-link">
                            Need Help?
                          </a>
                        </h6>
                      </div> */}
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default RequestPass;



// WEBPACK FOOTER //
// ./src/views/Pages/RequestPass.jsx